// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UAPS-","buttons":"styles_buttons__1WOus"};